export default {
  appSection: {
    title: {
      fr: "Une App unique.",
      en: "One unified app.",
    },
    subtitle: {
      fr: "Disponible sur iOS & Android.",
      en: "Available on iOS and Android.",
    },
    features: {
      title: {
        fr: "",
        en: "",
      },
      items: {
        app: {
          title: {
            fr: "Une expérience\nde A à Z...",
            en: "A seamless end-to-end experience",
          },
          description: {
            fr: "De l'installation initiale à l'usage quotidien,\nchaque moment est simple et intuitif.",
            en: "From initial setup to everyday use, every interaction is designed to be simple and intuitive.",
          },
        },
      },
    },
  },
};
